module.exports = __webpack_public_path__ + "img/copyright.3143bea8.jpg";